import React from 'react';
import './WelcomeSection.css';

const WelcomeSection = () => {
  return (
    <section className="welcome-section">
      <div className="container">
        <h2 className="section-title">PRAGATI VIDYALAYA FAMILY</h2>
        <div className="welcome-content">
          <p>
            We Welcome You to the PRAGATI VIDYALAYA FAMILY. With your co-operation, 
            we assure you that your child will have a most enjoyable and intersting 
            learning experience with us during the academic year ...
          </p>
          <button className="read-more-btn">Read More</button>
        </div>
        <div className="about-text">
          <p>
            A co-educational English medium school affiliated to the Central Board of 
            Secondary Education, PRAGATI VIDYALAYA aims to be much more than just a school. 
            We prepare our students to face their challenges in career and life, to be resilient 
            and empathetic citizens of the world. The PRAGATI VIDYALAYA offers a vibrant campus 
            complete with modern infrastructure, abundant space and state-of-the-art facilities 
            to give every child the freedom to explore, experience and excel.
          </p>
          <p>
            Located in Challakere, the school offers education in Pre-Primary, Primary, Middle, 
            Secondary and Higher Secondary sections.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;

